export default __webpack_public_path__ + "static/media/Google_Cloud.663f5499.png";